$(document).ready(function(){
  //問い合わせページの認証フロー
  $('#ContactPage__termsButton').on('click', function() {
    $('.ContactPage__formContainer').css('display','block');
    $('.ContactPage__terms').css('display','none');
  });
  
  //店舗情報ページ 現在地アプリ表示
  $('.Store__storeLocatorButton').on('click', function() {
    $('.Store__storeLocatorContainer').css('display','block');
  });
  
  
  //店舗情報の種別絞り込み
  var storeItem = $(".section-shop-area .list-items>li");
  
  $('.Store__typeInput').change(function() {
    var checked = [];
    $(".Store__typeInput:checked").each(function(){
      checked.push($(this).val());
    });
    console.log(checked);
    
    $(storeItem).each( function() {
      var storeType = $(this).data("store-type");
      var secondType = $(this).data("store-type2");
      
      var is_exist = $.inArray( storeType, checked );
      var check_second = $.inArray( secondType, checked );
      
      if (check_second != -1) {
        $(this).show();
      }else{
        if (is_exist != -1) {
          $(this).show();
        } else {
          $(this).hide();
        }
      }
      
    });
    
    if (!checked.length) {
      $(storeItem).show();
    }
  });
  
  
});

